import { FindNyukyoshaResult } from "~/api/data/Admin/Nyukyosha/FindNyukyoshaResult";
export class NyukyoshaListViewModel {
    constructor(model) {
        this.model = model;
    }
    model = new FindNyukyoshaResult();
    get userCd() {
        return this.model.userCd;
    }
    get nyukyokeiyakuNo() {
        return this.model.nyukyokeiyakuNo;
    }
    get userName() {
        return this.model.userName;
    }
    get nyukyoshaName() {
        return this.model.nyukyoshaName;
    }
    get buknCd() {
        return this.model.buknCd;
    }
    get buknName() {
        return this.model.buknName;
    }
    get roomNo() {
        return this.model.roomNo;
    }
    get unconfirmedFlag() {
        return this.model.unconfirmedFlag;
    }
    get jokyoKb() {
        return this.model.jokyoKb;
    }
}
